import { useState } from 'react'

export const useDrawerState = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState)

  const openDrawer = () => setIsOpen(true)
  const closeDrawer = () => setIsOpen(false)

  return {
    isOpen,
    openDrawer,
    closeDrawer,
  }
}
